import React from "react";
import { Image } from "react-bootstrap";
import whatsappIcon from "../assets/images/whatsapp-icon.png";

export default function WhatsAppButton({ phone }) {
  const phoneNumber = phone || "3153163451";
  const url = `https://wa.me/${phoneNumber}?text=Hola,%20me%20interesa%20sus%20servicios%20te%20visito%20desde%20la%20pagina`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
        backgroundColor: "#25d366",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      }}
    >
      <Image
        src={whatsappIcon}
        alt="WhatsApp"
        style={{ width: "35px", height: "35px" }}
        fluid
      />
    </a>
  );
}
